<template>
  <el-card>
    <!-- 页面标题，卡片头 -->
    <div slot="header" class="clearfix">
      <span>苗情监控</span>
      <el-radio-group v-model="park" size="small" style="float: right">
        <el-radio-button v-for="park in parks" :label="park.id" :key="park.id">
          {{ park.name }}
        </el-radio-button>
      </el-radio-group>
    </div>
    <el-row style="margin-bottom: 15px">
      <el-date-picker
        v-model="time"
        type="datetimerange"
        align="right"
        size="small"
        unlink-panels
        range-separator="至"
        start-placeholder="计划范围开始日期"
        end-placeholder="计划范围结束日期"
        :picker-options="pickerOptions0"
      >
      </el-date-picker>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="searchData"
      >
        搜索
      </el-button>
    </el-row>
    <!-- 页面主体内容 -->
    <el-row :gutter="20">
      <!-- 左侧地块选项 -->
      <el-col :span="3">
        <el-table
          ref="parkSelector"
          :data="lands"
          highlight-current-row
          :show-header="false"
          @current-change="landSelected"
        >
          <el-table-column prop="name"></el-table-column>
        </el-table>
      </el-col>
      <!-- 右侧页面主体内容 -->
      <el-col :span="21">
        <div style="overflow: auto; height: 550px; overflow-x: hidden">
          <el-row :gutter="10">
            <el-col :span="4" v-for="(item, index) in pictures" :key="index">
              <div class="demo-image__preview">
                <el-image
                  :src="imgBaseUrl + item"
                  :preview-src-list="getSrcList(index)"
                >
                </el-image>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
import { parkSearch } from '@/api/park.js'
import { getAreaData } from '@/api/land.js'
import { getInfoByCamera } from '@/api/equip.js'

export default {
  name: 'EvironmentMonitor',
  data() {
    return {
      count: 6,
      maxCount: 12,
      loading: false,
      time: [],
      /**
       * 当前选中的园区id
       */
      park: undefined,
      /**
       * 当前企业下辖的园区信息列表
       */
      parks: [],
      /**
       * 当前选中园区内地块列表
       */
      lands: [],
      /**
       * websocket客户端对象
       */
      flag: false,
      landId: undefined,
      pictures: [],
      dialogVisible: false,
      bigImageUrl: undefined,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      picturesOption: [],
    }
  },
  computed: {
    /**
     * 当前企业
     */
    currentEnterprise() {
      return this.$store.getters.currentEnterprise.id
    },
    noMore() {
      return this.count >= this.maxCount
    },
    disabled() {
      return this.loading || this.noMore
    },
    defaultImg() {
      return 'this.src="' + require('./loadError.png') + '"'
    },
    imgBaseUrl() {
      return process.env.HKIMG_BASE_URL
    
    },
  },
  watch: {
    /**
     * 监测当前园区，如果发生变化，则刷新地块列表
     */
    park: function (parkId) {
      if (parkId !== undefined) {
        // 初始化地块列表
        this.refreshLands()
      }
    },
  },
  mounted() {
    let now = new Date().format('yyyy-MM-dd hh:mm')
    let before = new Date(now).valueOf() * 1 - 1000 * 60 * 60 * 24
    let beforeTime = new Date(before).format('yyyy-MM-dd hh:mm')
    this.time = [beforeTime, now]
    // 初始化园区列表，把列表中首个园区设置为当前园区
    parkSearch({
      enterpriseId: this.currentEnterprise,
    }).then((resp) => {
      this.parks = resp.data.list
      this.park = this.parks[0].id
    })
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
  methods: {
    getSrcList(index) {
      return this.picturesOption
        .slice(index)
        .concat(this.picturesOption.slice(0, index))
    },
    wactchPic(src) {
      this.dialogVisible = true
      this.bigImageUrl = src
    },
    defaultImg(e) {
      console.log('图片加载失败', e.target)
    },
    load() {
      this.loading = true
      setTimeout(() => {
        this.count += 1
        this.loading = false
      }, 1000)
    },
    searchData() {
      this.count = 6
      let option = {
        staterTime: new Date(this.time[0]).valueOf(),
        endTime: new Date(this.time[1]).valueOf(),
      }
      let duringTime = option.endTime - option.staterTime
      console.log(option.endTime, option.staterTime)
      let num = duringTime / (1000 * 60 * 60)
      this.maxCount = num / 4
      console.log('照片数量', num)
      this.pictures = []
      this.picturesOption = []
      for (let i = 0; i <= num; i++) {
        let t1 = new Date(option.endTime - i * 1000 * 60 * 60).format(
          'yyyy/MM/dd'
        )
        let t2 = new Date(option.endTime - i * 1000 * 60 * 60).format(
          'yyyyMMddhh'
        )
        let url = `/${t1}/${this.landId}_${t2}_s.jpg`
        console.log( this.imgBaseUrl)
        let bigUrl = `${this.imgBaseUrl}/${t1}/${this.landId}_${t2}_m.jpg`
        this.pictures.push(url)
        this.picturesOption.push(bigUrl)
      }
    },
    /**
     * 某个地块被选中
     */
    landSelected(row) {
      this.landId = row.id
      this.searchData()
    },
    /**
     * 根据当前园区，刷新地块列表（在园区初始化或切换时调用），并默认选中第一个地块
     */
    refreshLands() {
      getAreaData({
        enterpriseId: this.currentEnterprise.id,
        parkId: this.park,
      }).then((resp) => {
        this.lands = resp.data.list
        this.landId = this.lands[0].id
        this.searchData()
        // this.$refs.parkSelector.setCurrentRow(this.lands[0])
        // this.landSelected(this.lands[0])
      })
    },
  },
}
</script>
<style scoped>
h4 {
  padding: 0;
  margin: 0;
}
li {
  list-style-type: none;
}
li::marker {
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/sapling/Index.vue